import { z } from 'zod';
export const claimCustomerPaymentStatus = z.enum([
    'Authorized',
    'Captured',
    'Refunded',
    'Expired',
]);
//# sourceMappingURL=claimCustomerPaymentStatus.js.map